import styled from "styled-components";
import { SECONDARY_DARK, PRIMARY } from '@etiquette-ui/colors';

export const Container = styled.div`
  position: relative;
  background-color: ${SECONDARY_DARK};

  &::before {
    content: '';
    width: 0px;
    height: 0px;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    border-bottom: 15px solid ${SECONDARY_DARK};
    position: absolute;
    top: -15px;
    right: 70px;
  }
`;

export const CloseIcon = styled.div`
  position: absolute;
  top: 5px;
  right: 15px;
`;

export const Body = styled.div`  
  padding: 15px 30px;
  text-align: center;
`;